module.exports = __webpack_public_path__ + "static/media/gameOver.df2fae12.jpg";